import { UnderMaintenance } from '@/components/ui';

export const ReportStockAdjustment = () => {
    return <UnderMaintenance />;
};

ReportStockAdjustment.displayName = 'ReportStockAdjustment';
